import { LANGUAGE_SLUG_BY_CODE } from '@repo/sdk';
import type { IPaletteItem } from '@repo/web-chrome/components/command-palette/palette-item-types';
import type { INativeLanguageContent } from '@/content/native';

type LanguageCodeType = keyof typeof LANGUAGE_SLUG_BY_CODE;

export function nativePagesRegistry(
  content: Record<string, INativeLanguageContent>,
): IPaletteItem[] {
  const items: IPaletteItem[] = [];
  for (const [code, entry] of Object.entries(content)) {
    const slug = LANGUAGE_SLUG_BY_CODE[code as LanguageCodeType];
    if (!slug) {
      continue;
    }
    items.push({
      id: `page:for-${code}`,
      group: 'pages',
      title: entry.englishName,
      subtitle: entry.nativeName,
      href: `/for/${slug}`,
      keywords: [entry.englishName, entry.nativeName, code, slug, 'native', 'for'],
      iconName: 'globe',
    });
  }
  return items;
}
